<template>
    <div class="centerPage">
        <div class="pageTit">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/admin/dict/list'}">字典管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/admin/dict/edit?id='+catalogId}">字典编辑</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/admin/dict/item/edit?catalogId='+catalogId+'&id='+editData.itemId}">二级编辑</el-breadcrumb-item>
                <el-breadcrumb-item>三级编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-form ref="form" class="article_edit">

            <el-form-item label="字典名称：">
                <el-input v-model="editData.subName" style="width: 1000px" placeholder="请输入字典名称">
                </el-input>
            </el-form-item>
            <el-form-item label="字典代码：">
                <el-input v-model="editData.subCode" style="width: 1000px" placeholder="请输入字典代码">
                </el-input>
            </el-form-item>
            <el-form-item label="类型：">
                <el-radio-group v-model="editData.subType" class="type">
                    <el-radio :label="1">可编辑</el-radio>
                    <el-radio :label="0">不可编辑</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="状态：">
                <el-radio-group v-model="editData.status" class="type">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="字典描述：">
                <el-input v-model="editData.subDesc" style="width: 1000px" placeholder="请输入字典描述" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                </el-input>
            </el-form-item>
            <el-form-item label="备注：">
                <el-input v-model="editData.remark" style="width: 1000px" placeholder="请输入备注" :autosize="{ minRows: 2, maxRows: 5}" type="textarea">
                </el-input>
            </el-form-item>
            <div class="btn">
                <el-button @click="toUpdate" v-if="editId">更新</el-button>
                <el-button @click="toSave" v-else>添加</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import commonjs from "../../../api/common";
    export default {
        name: "subEdit",
        data() {
            return {
                editData: {
                    subCode: "",
                    subDesc: "",
                    subName: "",
                    subType: "",
                    id: "",
                    remark: "",
                    haveSubItem: "",
                    itemId: this.$route.query.itemId,
                },
                editId: this.$route.query.id,
                catalogId: this.$route.query.catalogId
            }
        },
        mounted() {
            if (this.editId != null) {
                this.getEditData();
            }
        },
        methods: {
            getEditData() {
                let that = this;
                this.$ajax
                    .get(commonjs.api.dict.edit.sub.detail.replace("{id}",this.editId))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                            that.editData = res.data.data;
                        } else {
                            that.$message.error(res.data.message);
                        }
                    })
            },
            toSave() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.sub.save,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.toPush()
                      } else {
                        that.$message.error(res.data.message);
                      }
                    })
            },
            toUpdate() {
                let that = this;
                this.$ajax
                    .post(commonjs.api.dict.edit.sub.update,this.editData)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.$message.success('操作成功');
                        that.toPush()
                      } else {
                        that.$message.error(res.data.message);
                      }
                    })
            },
            toPush() {
                this.$router.push({name: 'dictItemEdit',query: {catalogId: this.catalogId,id: this.editData.itemId}})
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../assets/css/banner.scss';

    .centerPage {
        display: block;
    }
</style>